<template>
  <v-card outlined>
    <v-card-title>
      Saídas Estratégicas
      <v-spacer></v-spacer>
      <v-btn text color="primary" :disabled="!dataInicio" @click="carregarExemplos()">
        <v-icon left>mdi-lightbulb-on-outline</v-icon> Carregar exemplos
      </v-btn>
      <v-btn text color="primary" @click="openDialog()">
        <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar saída
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      Projete os desembolsos da turma. Apenas saídas ativadas entram no cálculo —
      use "Carregar exemplos" para começar com modelos editáveis.
    </v-card-subtitle>
    <v-data-table
      :headers="headers"
      :items="saidas"
      no-data-text="Nenhuma saída cadastrada"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
      sort-by="mes"
    >
      <template v-slot:item.valor="{ item }">{{ item.valor | price }}</template>
      <template v-slot:item.ativado="{ item }">
        <v-switch v-model="item.ativado" hide-details class="mt-0" @change="emitChange"></v-switch>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn color="error" fab text small @click="remove(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>Nova saída</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-text-field label="Mês (yyyy-MM)" v-model="form.mes" type="month" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12">
              <decimal-number label="Valor" v-model="form.valor" outlined dense></decimal-number>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Descrição" v-model="form.descricao" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" class="d-flex align-center">
              <v-switch v-model="form.ativado" label="Ativado" hide-details class="mt-0"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" :disabled="!form.mes" @click="save">Adicionar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { addMonths, format } from 'date-fns'
import DecimalNumber from '@/components/DecimalNumber'

function emptyForm () {
  return {
    mes: '',
    valor: 0,
    descricao: '',
    ativado: true
  }
}

// Modelos de saída baseados nas categorias reais de desembolso do negócio
// (resgate, plano Heppi, cashback). São apenas pontos de partida editáveis.
const EXEMPLOS = [
  { offset: 6, valor: 5000, descricao: 'Resgate parcial' },
  { offset: 12, valor: 2000, descricao: 'Plano Heppi (anuidade)' },
  { offset: 24, valor: 1500, descricao: 'Cashback' },
  { offset: 36, valor: 3000, descricao: 'Resgate parcial' }
]

export default {
  name: 'TabSaidasEstrategicas',
  components: { DecimalNumber },
  props: {
    saidas: { type: Array, default: () => [] },
    dataInicio: { type: String, default: '' },
    horizonteMeses: { type: Number, default: 0 }
  },
  data: () => ({
    dialog: false,
    form: emptyForm(),
    headers: [
      { text: 'Mês', value: 'mes' },
      { text: 'Valor', value: 'valor' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Ativado', value: 'ativado', sortable: false },
      { text: '', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    openDialog () {
      this.form = emptyForm()
      this.dialog = true
    },
    carregarExemplos () {
      if (!this.dataInicio) return
      const base = new Date(`${this.dataInicio}T12:00:00.000Z`)
      const novos = EXEMPLOS
        .filter(e => e.offset < this.horizonteMeses)
        .map(e => ({
          mes: format(addMonths(base, e.offset), 'yyyy-MM'),
          valor: e.valor,
          descricao: e.descricao,
          ativado: true
        }))
      this.$emit('update', [...this.saidas, ...novos])
      this.emitChange()
    },
    save () {
      this.$emit('update', [...this.saidas, { ...this.form }])
      this.dialog = false
      this.emitChange()
    },
    remove (item) {
      this.$emit('update', this.saidas.filter(i => i !== item))
      this.emitChange()
    },
    emitChange () {
      // Notifica o pai para recalcular usando apenas saídas ativadas.
      this.$nextTick(() => this.$emit('change'))
    }
  }
}
</script>
